import {
  CircularProgress,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { FunctionComponent, useMemo, useState } from "react";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";
import Checkbox from "../../components/ui/Checkbox";
import Button from "../../components/ui/Button";
import { InfoIcon } from "../../assets/Icons";
import { Mixpanel } from "../../constants/mixpanel";
import TabPanel from "./TabPanel";

const useStyles = makeStyles(() => ({
  label: {
    marginLeft: "12px",
  },
}));

export const StepThree: FunctionComponent<IRecipientDetailsProps.StepThreeProps> = ({
  bankCountry,
  setBankCountry,
  setAcNumber,
  acNumber,
  setConfirmAcNumber,
  confirmAcNumber,
  swiftCode,
  setSwiftCode,
  iban,
  setIban,
  countryList,
  bankName,
  setBankName,
  routingNumber,
  setRoutingNumber,
  transitCode,
  setTransitCode,
  bspCode,
  setBspCode,
  sortCode,
  setSortCode,
  refrence,
  setRefrence,
  bankAddress,
  setBankAddress,
  isCorrespondingAccount,
  setIsCorrespondingAccount,
  isVerified,
  setIsVerified,
  handleVerify,
  validationError,
  residenceCountry,
  loading,
  isLoading,
}) => {
  const [isSwift, setIsSwift] = useState<boolean>(false);
  const classes = useStyles();
  const ibanCountryArray: any = [
    "Germany",
    "France",
    "United Kingdom",
    "Belgium",
    "United Arab Emirates",
    "Italy",
    "Brazil",
    "Portugal",
  ];
  const codeCountry = ["Australia", "Canada", "United Kingdom", "United States"];
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  const enableSwitch = useMemo(() => {
    const tabSwitch = isVerified ? false : true;
    return tabSwitch;
  }, [iban, swiftCode, isVerified]);

  return (
    <div className="space-y-6  flex flex-col items-center justify-center">
      <div className="text-sm font-bold">
        <div className="flex flex-col items-center">
          <div>
            Fill {ibanCountryArray.includes(residenceCountry) && <span>any one of</span>} the
            following to verify
          </div>
          {!ibanCountryArray.includes(residenceCountry) && (
            <TabPanel isSwift={isSwift} setIsSwift={setIsSwift} switchTab={enableSwitch} />
          )}
        </div>
        {isVerified && (
          <div
            onClick={() => {
              if (iban) {
                setSwiftCode("");
              }
              setIsVerified(!isVerified);
            }}
            className="text-blue-600 cursor-pointer text-center w-full"
          >
            Edit Field
          </div>
        )}
      </div>
      <div className="flex flex-col items-center lg:flex-row">
        <div className="flex flex-col items-center space-x-4 space-y-2 lg:flex-row lg:space-y-0">
          {/* {!ibanCountryArray.includes(residenceCountry) && (
            <TextField
              className="w-[300px]"
              name="username"
              placeholder="Swift Code"
              variant="outlined"
              required={true}
              onChange={(e) => setSwiftCode(e.target.value)}
              value={swiftCode}
              disabled={isVerified}
              inputProps={{ pattern: { specialCharRegExp } }}
            />
          )}
          {!ibanCountryArray.includes(residenceCountry) && <span className="lg:mr-2">Or</span>} */}
          <TextField
            className="w-[300px]"
            name="username"
            placeholder={isSwift ? "Swift" : "IBAN Number"}
            variant="outlined"
            required={true}
            onChange={(e) => (isSwift ? setSwiftCode(e.target.value) : setIban(e.target.value))}
            value={isSwift ? swiftCode : iban}
            disabled={isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
        </div>
        <Button
          bgColor={!isVerified ? "bg-[#06224B]" : "bg-[#37C820]"}
          fontStyle={{
            fontFamily: "font-roboto",
            fontSize: "text-base",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          className="py-4 lg:px-[8%] px-[20%] mr-2 mt-[1.8rem] lg:mt-[0px] ml-4"
          onClickHandler={handleVerify}
          disabled={isVerified}
          isLoading={isLoading}
        >
          {isVerified ? "Verified" : "Verify"}
        </Button>
        {loading && !validationError && <CircularProgress />}
      </div>
      {validationError && (
        <span className="text-sm" style={{ color: "red" }}>
          {validationError}
        </span>
      )}
      {isVerified && (
        <div className="w-[105%] mx-auto mb-4 overflow-hidden border border-[#E3E3E3] mt-2 border-solid ml-[-3%]"></div>
      )}
      {isVerified && (
        <div id="line1" className="flex space-x-20">
          <TextField
            className="w-[400px]"
            name="username"
            label="Bank Account Number"
            variant="outlined"
            required={true}
            onChange={(e) => setAcNumber(e.target.value)}
            value={acNumber}
            disabled={!isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
          <div className="flex flex-col">
            <TextField
              className="w-[400px]"
              name="username"
              label="Confirm Bank Account Number"
              variant="outlined"
              required={true}
              onChange={(e) => setConfirmAcNumber(e.target.value)}
              value={confirmAcNumber}
              disabled={!isVerified}
            />
            {confirmAcNumber !== acNumber && confirmAcNumber && (
              <span className="text-red-500 text-[14px] ml-3">
                The account numbers do not match.
              </span>
            )}
          </div>
        </div>
      )}
      {isVerified && (
        <div id="line2" className="flex space-x-20">
          <FormControl className="w-[400px]">
            <InputLabel className={classes.label} id="demo-simple-select-label">
              Bank Account Country
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              variant="outlined"
              value={bankCountry}
              label="Bank Account Country"
              onChange={(e) => setBankCountry(e.target.value)}
              style={{ padding: "1px" }}
              disabled={!isVerified}
            >
              {countryList.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            className="w-[400px]"
            name="username"
            label="Bank Name"
            variant="outlined"
            required
            onChange={(e) => setBankName(e.target.value)}
            value={bankName}
            disabled={!isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
        </div>
      )}
      {isVerified && (
        <div id="line4" className="flex space-x-20">
          <div className="flex flex-col">
            <TextField
              className="w-[400px]"
              name="code"
              type="text"
              label={
                bankCountry === "United States"
                  ? "Routing Number"
                  : bankCountry === "Canada"
                    ? "Transit Code"
                    : bankCountry === "Australia"
                      ? "BSB Code"
                      : bankCountry === "United Kingdom"
                        ? "Sort Code"
                        : "Sort/BSB/Transit/Routing(Optional)"
              }
              variant="outlined"
              required={bankCountry === "United States" || bankCountry === "Canada" || bankCountry === "Australia" || bankCountry === "United Kingdom"  ? true : false}
              onChange={(e) =>
                bankCountry === "United States"
                  ? setRoutingNumber(e.target.value)
                  : bankCountry === "Canada"
                    ? setTransitCode(e.target.value)
                    : bankCountry === "Australia"
                      ? setBspCode(e.target.value)
                      : bankCountry === "United Kingdom"
                        ? setSortCode(e.target.value)
                        : "Code*"
              }
              value={
                bankCountry === "United States"
                  ? routingNumber
                  : bankCountry === "Canada"
                    ? transitCode
                    : bankCountry === "Australia"
                      ? bspCode
                      : bankCountry === "United Kingdom"
                        ? sortCode
                        : ""
              }
              disabled={!codeCountry.includes(bankCountry)}
            />
          </div>
          <TextField
            className="w-[400px]"
            name="refrence"
            label="Reference ID"
            variant="outlined"
            onChange={(e) => setRefrence(e.target.value)}
            value={refrence}
            disabled={!isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
        </div>
      )}
      {isVerified && (
        <div id="line4" className="flex px-2 w-full space-x-20">
          <TextField
            className="w-full "
            name="refrence"
            label="Bank Address"
            variant="outlined"
            onChange={(e) => setBankAddress(e.target.value)}
            value={bankAddress}
            disabled={!isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
        </div>
      )}
      {isVerified && (
        <div id="line4" className="flex space-x-20">
          <TextField
            className="w-[400px]"
            name="swift code"
            label="Unit Number"
            tabIndex={1}
            disabled={!isVerified}
            inputProps={{ pattern: { specialCharRegExp } }}
          />
          <div className="relative flex items-center w-full space-x-3 group">
            <Checkbox
              label="Click if your recipient has a corresponding account"
              value=""
              handleChange={() => {
                setIsCorrespondingAccount(!isCorrespondingAccount);
                Mixpanel.track("Corresponding_account_checked");
              }}
            />
            <div className="transition-all cursor-pointer hover:scale-105">
              <InfoIcon />
            </div>
            <div className="absolute flex-col items-center justify-center hidden px-5 w-[500px] text-[14px] py-4 mt-[160px] font-semibold text-white rounded-lg shadow-xl bg-primary group-hover:flex animate-fade">
              <span className="font-bold text-[16px]">What is a corresponding account?</span>
              <span>
                A correspondent account is a bank account set up to handle transactions for another
                financial institution.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
